import { useMemo } from 'react'
import { DeleteOutline } from '@mui/icons-material'
import CameraIcon from '@mui/icons-material/CameraOutlined'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, styled } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import { drawerVar } from '../../../../../providers/apollo/cache'
import useBucket from '../../../hooks/useBucket'
import { BucketUserRole } from '../../../../../graphql/generated'

// Styles for descendants of the listItem
export const StyledListItem = styled(ListItem)(({ theme }) => ({
  marginTop: 0,
  '& .MuiListItemButton-root': {
    borderRadius: '4px',
    padding: '4px 0',
    color: theme.palette.text.primary,
    '& .MuiListItemIcon-root': { color: 'inherit', minWidth: '36px' },
    '& .MuiListItemText-primary': { color: 'inherit', fontWeight: 500 },
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main
    }
  }
}))

const ROUTES = {
  bucket: (id: string | undefined) => `/bucket/${id}`,
  activity: (id: string | undefined) => `/bucket/${id}/activity`,
  trash: (id: string | undefined) => `/bucket/${id}/trash`,
  share: (id: string | undefined) => `/bucket/${id}/share`,
  sharing: (id: string | undefined) => `/bucket/${id}/sharing`
}

type RouteKey = keyof typeof ROUTES

export default function BottomStaticAlbums() {
  const { bucket, bucketUser } = useBucket()
  const bucketId = bucket?.id
  const navigate = useNavigate()
  const location = useLocation()

  const isCurrentRoute = useMemo(() => {
    return (route: string) => location.pathname === route
  }, [location])

  const handleNavigation = (path: RouteKey) => () => {
    const route = ROUTES[path](bucketId)
    if (route) {
      navigate(route)
      drawerVar(null)
    }
  }

  return (
    <List sx={{ paddingTop: '2px' }}>
      <StyledListItem disablePadding>
        <ListItemButton onClick={handleNavigation('activity')} selected={isCurrentRoute(ROUTES.activity(bucketId))} data-test="activity-feed">
          <ListItemIcon>
            <CameraIcon />
          </ListItemIcon>
          <ListItemText primary="Activity" />
        </ListItemButton>
      </StyledListItem>

      {bucketUser?.userRole !== BucketUserRole.Viewer && (
        <StyledListItem disablePadding>
          <ListItemButton
            onClick={handleNavigation('trash')}
            selected={isCurrentRoute(ROUTES.trash(bucketId))}
            data-testid="bucket-left-drawer-trash"
          >
            <ListItemIcon>
              <DeleteOutline />
            </ListItemIcon>
            <ListItemText primary="Trash" />
          </ListItemButton>
        </StyledListItem>
      )}
    </List>
  )
}
